// src/helpers/menu/buckets/categories.ts
var getCategoryChildrenType = (subcategoryMenuTypeItemsIds, subcategoryMenuTypeCombosIds) => {
  const subcategoryItemIds = Object.keys(subcategoryMenuTypeItemsIds).map(
    Number
  );
  const subcategoryComboIds = Object.keys(subcategoryMenuTypeCombosIds).map(
    Number
  );
  if ((subcategoryItemIds.length === 0 || subcategoryItemIds.length === 1 && subcategoryItemIds[0] === 0) && (subcategoryComboIds.length === 0 || subcategoryComboIds.length === 1 && subcategoryComboIds[0] === 0)) {
    return "item" /* ITEM */;
  }
  return "subcategory" /* SUBCATEGORY */;
};

export { getCategoryChildrenType };
